import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppState, Store, AppTypes, StorageUtil } from '../../store';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.css']
})
export class RedirectComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store: Store<AppState>
  ) { }

  ngOnInit() {
    localStorage.removeItem('clubId');
    localStorage.removeItem('teamId');
    localStorage.removeItem('tokenValue');
    localStorage.removeItem('userId');
    localStorage.removeItem('roleId');
    localStorage.removeItem('firebaseConfig');

    const params = this.route.snapshot.queryParams;

    let redirect = '';
    if (params && params['tokenValue'] && params['tab']) {
      if (params['tab'] === 'eval') {
        redirect = '/staff/all/evaluations';
      }
      else if (params['tab'] === 'team') {
        redirect = '/team-admin';
        localStorage.setItem('roleId', params['rid']);
      }
      else if (params['tab'] === 'event') {
        //Redirect To Event Details
        redirect = '/team-admin/events/dashboard/' + params['eid'];
        //Set Local Storage Values
        localStorage.setItem('clubId', params['cid']);
        localStorage.setItem('teamId', params['tid']);
        localStorage.setItem('roleId', params['rid']);
      }
      else if (params['tab'] === 'team-account') {
        //Redirect To Event Details
        redirect = '/team-admin/my-teams';
        localStorage.setItem('roleId', params['rid']);
      }

      StorageUtil.params = { ...params, redirect };
      this.store.dispatch({
        type: AppTypes.ValidateUser
      });

      //this.store.dispatch({
      //  type: AppTypes.InitializeUser,
      //  payload: {
      //    userId: params['tokenValue']
      //  }
      //});

    } else if (params && params['clubId'] && params['tokenValue']) {
      StorageUtil.params = {
        ...params,
        redirect: params['assoc'] === 'true' ? '/association' : params['teamId'] ? '/team-billing/programs/active' : '/club/dashboard'
      };
      this.store.dispatch({
        type: AppTypes.ValidateUser
      });
      this.store.dispatch({
        type: AppTypes.InitializeClub,
        payload: {
          clubId: params['clubId']
        }
      });
    } else {
      this.router.navigate(['/401']);
    }
      }
 }



// WEBPACK FOOTER //
// ./src/app/pages/redirect/redirect.component.ts